module.exports = __webpack_public_path__ + "static/media/IrockPromoWeb.4cd6f73d.webm";